<template>
<section>
    <v-card flat>
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="6" offset-md="3">
            <v-row style="margin:0">
              <v-col cols="8">
                <h4 style="margin-top:6px">Descripción</h4>
              </v-col>
              <v-col cols="4" style="display:flex;justify-content:flex-end;">
                <v-chip color="rapired" dark>{{ currentBudget.status_budget.name }}</v-chip>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="currentBudget.description"
                  :readonly="editBudgetDisabled"
                  @change="saveBudget"
                  :error="$v.currentBudget.description.$error"
                  @input="$v.currentBudget.description.$touch()"
                  :error-messages="descriptionErrors"
                  :autofocus="isNewBudget"
                  auto-grow rows="1"
                  style="margin-top:0;padding-top:0"
                ></v-textarea>
              </v-col>
              <v-col cols="8">
                <h4>Mano de obra</h4>
              </v-col>
              <v-col cols="4">
                <h4 align="right">${{ manpowerTotalAmount }}</h4>
              </v-col>
              <v-col cols="12" style="padding-top:0;padding-bottom:0;">
                <v-row v-for="(item, i) in currentBudget.items_manpower" :key="i" @click="showBudgetItemDialog('manpower', item, i)">
                  <v-col cols="8" md="10" style="padding-bottom:0">
                    <p style="margin:0">{{ item.description }} (x{{ item.cant }})</p>
                  </v-col>
                  <v-col cols="4" md="2" style="padding-bottom:0">
                    <p style="margin:0" align="right">${{ item.amount }}</p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" style="display:flex;justify-content:center;">
                <v-btn text color="rapired" @click="showBudgetItemDialog('manpower', null, null)" :disabled="addItemsDisabled">
                  + AGREGAR ITEM MANO DE OBRA
                </v-btn>
              </v-col>
              <v-col cols="8">
                <h4>Insumos</h4>
              </v-col>
              <v-col cols="4">
                <h4 align="right">${{ suppliesTotalAmount }}</h4>
              </v-col>
              <v-col cols="12" style="padding-top:0;padding-bottom:0;">
                <v-row v-for="(item, i) in currentBudget.items_supplies" :key="i" @click="showBudgetItemDialog('supplies', item, i)">
                  <v-col cols="8" md="10" style="padding-bottom:0">
                    <p style="margin:0">{{ item.description }} (x{{ item.cant }})</p>
                  </v-col>
                  <v-col cols="4" md="2" style="padding-bottom:0">
                    <p style="margin:0" align="right">${{ item.amount }}</p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" style="display:flex;justify-content:center;">
                <v-btn text color="rapired" @click="showBudgetItemDialog('supplies', null, null)" :disabled="addItemsDisabled">
                  + AGREGAR ITEM INSUMOS
                </v-btn>
              </v-col>
              <v-col cols="8">
                <h4>Total</h4>
              </v-col>
              <v-col cols="4">
                <h4 align="right">${{ budgetTotalAmount }}</h4>
              </v-col>
              <v-col v-if="!editBudgetDisabled" cols="12" style="display:flex;justify-content:center;">
                <v-btn :disabled="requestApprovalDisabled" color="secondary" @click="requestApproval">SOLICITAR APROBACIÓN</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-container>

    </v-card>
  <BudgetItemDialog
    v-if="budgetItemDialog"
    :show="budgetItemDialog"
    :item="selectedItem"
    :type="selectedItemType"
    @save-item="saveItem($event)"
    @delete-item="deleteItem()"
    @close-dialog="budgetItemDialog=false"
  />
</section>
</template>
<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'

import BudgetItemDialog from './AppBudgetItemDialog'

export default {
  name: 'budget-detail',
  components: {
    BudgetItemDialog
  },
  data () {
    return {
      techReq: {},
      setTimeout: null,
      budgetItemDialog: false,
      selectedItem: null,
      selectedItemType: null,
      selectedItemIndex: null,
      currentBudget: {
        status_budget: {
          id: 1,
          name: 'Nuevo'
        },
        request_technician: null,
        description: '',
        items_manpower: [],
        items_supplies: []
      }
    }
  },
  validations () {
    const validations = {
      currentBudget: {
        description: { required }
      }
    }
    return validations
  },
  created () {
    this.$store.commit('set_last_screen', 'budget-detail')
    this.techReq = this.$store.state.current_techReq
    if (this.$store.state.current_budget.id) this.currentBudget = { ...this.$store.state.current_budget }
  },
  mounted () {
    this.$store.commit('set_app_title', this.dialogTitle)
    window.scrollTo(0, 0)
  },
  computed: {
    isNewBudget: function () {
      if (!this.currentBudget.id) return true
      return false
    },
    dialogTitle: function () {
      if (this.currentBudget.id && !this.editBudgetDisabled) {
        return 'Editar presupuesto'
      } else if (this.currentBudget.id && this.editBudgetDisabled) {
        return 'Presupuesto'
      }
      return 'Nuevo presupuesto'
    },
    manpowerTotalAmount: function () {
      let totalAmount = 0
      this.currentBudget.items_manpower.forEach(item => {
        totalAmount = totalAmount + Number(item.amount) * Number(item.cant)
      })
      return totalAmount
    },
    suppliesTotalAmount: function () {
      let totalAmount = 0
      this.currentBudget.items_supplies.forEach(item => {
        totalAmount = totalAmount + Number(item.amount) * Number(item.cant)
      })
      return totalAmount
    },
    budgetTotalAmount: function () {
      return this.manpowerTotalAmount + this.suppliesTotalAmount
    },
    addItemsDisabled: function () {
      if (!this.currentBudget.id || this.currentBudget.status_budget.id !== 1 || this.$v.currentBudget.$error) return true
      return false
    },
    editBudgetDisabled: function () {
      if (this.currentBudget.status_budget.id !== 1) return true
      return false
    },
    editItemDisabled: function () {
      if (this.currentBudget.status_budget.id !== 1 || this.$v.currentBudget.$error) return true
      return false
    },
    requestApprovalDisabled: function () {
      if (!this.currentBudget.id || this.budgetTotalAmount === 0 || this.$v.currentBudget.$error) return true
      return false
    },
    descriptionErrors: function () {
      const errors = []
      if (!this.$v.currentBudget.description.$error) return errors
      !this.$v.currentBudget.description.required && errors.push('Este campo es requerido')
      return errors
    }
  },
  methods: {
    showBudgetItemDialog (itemType, selectedItem, selectedItemIndex) {
      if (!this.editBudgetDisabled && !this.editItemDisabled) {
        selectedItem ? this.selectedItem = selectedItem
          : this.selectedItem = { description: null, cant: 1, amount: null }
        this.selectedItemIndex = selectedItemIndex
        this.selectedItemType = itemType
        this.budgetItemDialog = true
      }
    },
    deleteItem () {
      switch (this.selectedItemType) {
        case 'manpower':
          this.currentBudget.items_manpower.splice(this.selectedItemIndex, 1)
          break
        case 'supplies':
          this.currentBudget.items_supplies.splice(this.selectedItemIndex, 1)
          break
      }
      this.saveBudget()
    },
    saveItem (item) {
      if (!this.selectedItemIndex) {
        switch (this.selectedItemType) {
          case 'manpower':
            this.currentBudget.items_manpower.push(item)
            break
          case 'supplies':
            this.currentBudget.items_supplies.push(item)
            break
        }
      } else {
        switch (this.selectedItemType) {
          case 'manpower':
            this.currentBudget.items_manpower[this.selectedItemIndex] = item
            break
          case 'supplies':
            this.currentBudget.items_supplies[this.selectedItemIndex] = item
            break
        }
      }
      this.saveBudget()
    },
    saveBudget () {
      this.$v.currentBudget.$touch()
      if (!this.$v.currentBudget.$error) {
        if (!this.currentBudget.id) {
          this.currentBudget.request_technician = this.techReq.id
          this.axios.post('/budget/', this.currentBudget).then(response => {
            this.currentBudget = response.data
            this.$store.commit('show_alert', 'Cambios guardados correctamente')
            this.$store.commit('set_current_budget', this.currentBudget)
          }).catch(err => {
            alert(err)
          })
        } else {
          this.axios.put(`/budget/${this.currentBudget.id}/`, this.currentBudget).then(response => {
            this.currentBudget = response.data
            this.$store.commit('show_alert', 'Cambios guardados correctamente')
            this.$store.commit('set_current_budget', this.currentBudget)
          }).catch(err => {
            alert(err)
          })
        }
      }
    },
    requestApproval () {
      this.axios.post(`/budget/${this.currentBudget.id}/send/`, {}).then(response => {
        Object.assign(this.currentBudget.status_budget, response.data.status_budget)
        this.$store.commit('show_alert', 'Cambios guardados correctamente')
        this.$store.commit('set_current_budget', this.currentBudget)
      }).catch(err => {
        alert(err)
      })
    },
    formatDate (date) {
      const _date = new Date()
      const today = moment(_date).format('YYYY-MM-DD')
      if (date === today) {
        return 'Hoy'
      } else {
        return moment(date, 'YYYY-MM-DD').format('dddd DD MMMM, YYYY')
      }
    }
  }
}
</script>
<style scoped>
  @media(min-width:960px){
    .pull-right-on-desktop {
      display: flex;
      justify-content: flex-end;
    }
  }
  .bottom-bar {
    position: fixed;
    padding: 0 24px;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 88px;
    display: flex;
    justify-content: flex-end;
  }
  .pb24 {
    padding-bottom: 84px;
  }
  .pb0 {
    padding-bottom: 0;
  }
  .pt0 {
    padding-top: 0;
  }
  .p0 {
    padding: 0;
  }
  .m0 {
    margin: 0;
  }
  .date {
    text-transform: capitalize;
    text-align: left;
  }
  .status-name-cont {
    height: 30px;
    background: #c8272a;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 12px;
    text-transform: capitalize;
  }
</style>
